import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SettingsService } from './services/settings.service';
import { AuthGuardService } from './guards/auth-guard.service';
import { AuthRoleGuardService } from './guards/auth-role-guard.service';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import {
  DEFAULT_TIMEOUT,
  TimeoutInterceptor,
} from './interceptors/timeout.interceptor';

import { AccessService } from './services/access.service';

// import { AuthGuard } from './guards/auth.guard';
// import { AuthService } from './services/auth.service';

@NgModule({
  imports: [HttpClientModule], // ✅ Make HttpClient available app-wide
  exports: [],
  providers: [
    AuthGuardService,
    AuthRoleGuardService,
    AccessService, // ✅ Singleton providers
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    [{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true }],
    [{ provide: DEFAULT_TIMEOUT, useValue: 30000 }],
  ],
})
export class CoreModule {}
